export function fmtLocalDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { month: '2-digit', day: '2-digit' }) +
    ' ' + d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
}

export function fmtMonthDay(yyyyMMdd: string): string {
  const [y, m, d] = yyyyMMdd.split('-').map(Number);
  if (!y || !m || !d) return yyyyMMdd;
  const date = new Date(Date.UTC(y, m - 1, d));
  return date.toLocaleDateString(undefined, { month: 'short', day: '2-digit', timeZone: 'UTC' });
}

export function fmtYear(yyyyMMdd: string): string {
  return yyyyMMdd.slice(0, 4);
}

export function truncate(s: string, n: number): string {
  return s.length <= n ? s : s.slice(0, n).trimEnd() + '…';
}
